exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-select .list {\n  max-height: 173px;\n  min-height: 173px;\n}", ""]);

// exports
